"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preventThrow = void 0;
/**
 * Make a promise return its rejection
 */
const preventThrow = (p) => p.catch((e) => e);
exports.preventThrow = preventThrow;
//# sourceMappingURL=preventThrow.js.map